import React from "react";

function CommentIcon({...props}) {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='30'
            height='30'
            viewBox='0 0 48 48'
            fill='none'
            {...props}
        >
            <rect x='4' y='4' width='40' height='40' rx='20' fill='#F2F4F7' />
            <rect
                x='4'
                y='4'
                width='40'
                height='40'
                rx='20'
                stroke='#F9FAFB'
                stroke-width='8'
            />
            <path
                d='M18 34C17.8106 33.9998 17.629 33.9245 17.4951 33.7906C17.3612 33.6567 17.2859 33.4751 17.2857 33.2857V29.7143H15.1429C13.9614 29.7143 13 28.7529 13 27.5714V16.1429C13 14.9614 13.9614 14 15.1429 14H32.2857C33.4671 14 34.4286 14.9614 34.4286 16.1429V27.5714C34.4286 28.7529 33.4671 29.7143 32.2857 29.7143H23.6079L18.4464 33.8436C18.3198 33.945 18.1623 34.0002 18 34ZM15.1429 15.4286C14.7486 15.4286 14.4286 15.7493 14.4286 16.1429V27.5714C14.4286 27.965 14.7486 28.2857 15.1429 28.2857H18C18.1894 28.2857 18.3711 28.361 18.5051 28.4949C18.639 28.6289 18.7143 28.8106 18.7143 29V31.8L22.9107 28.4421C23.0374 28.3408 23.1949 28.2856 23.3571 28.2857H32.2857C32.68 28.2857 33 27.965 33 27.5714V16.1429C33 15.7493 32.68 15.4286 32.2857 15.4286H15.1429Z'
                fill='#475467'
            />
            <path
                d='M29.4285 21.1428H17.9999C17.8105 21.1428 17.6288 21.0675 17.4949 20.9336C17.3609 20.7996 17.2856 20.618 17.2856 20.4285C17.2856 20.2391 17.3609 20.0574 17.4949 19.9234C17.6288 19.7895 17.8105 19.7142 17.9999 19.7142H29.4285C29.6179 19.7142 29.7996 19.7895 29.9336 19.9234C30.0675 20.0574 30.1428 20.2391 30.1428 20.4285C30.1428 20.618 30.0675 20.7996 29.9336 20.9336C29.7996 21.0675 29.6179 21.1428 29.4285 21.1428ZM23.7142 23.9999H17.9999C17.8105 23.9999 17.6288 23.9247 17.4949 23.7907C17.3609 23.6568 17.2856 23.4751 17.2856 23.2857C17.2856 23.0962 17.3609 22.9145 17.4949 22.7806C17.6288 22.6466 17.8105 22.5714 17.9999 22.5714H23.7142C23.9037 22.5714 24.0853 22.6466 24.2193 22.7806C24.3532 22.9145 24.4285 23.0962 24.4285 23.2857C24.4285 23.4751 24.3532 23.6568 24.2193 23.7907C24.0853 23.9247 23.9037 23.9999 23.7142 23.9999Z'
                fill='#475467'
            />
        </svg>
    );
}

export default CommentIcon;
